export default __webpack_public_path__ + "static/media/I0003.e5f72f26.png";